<script lang="ts" setup>
	import type { IAdmin } from "~/server/models/admin";
	import type { IUser } from "~/server/models/user";
	import type { Sizes } from "~/utils/enums";

	const props = defineProps<{
		record?: IUser | IAdmin;
		size: Sizes;
	}>();

	//

	const color = computed(() => {
		return "black";
	});

	const width = computed(() => {
		if (props.size === "small") {
			return 42;
		} else if (props.size === "medium") {
			return 56;
		} else {
			return 96;
		}
	});

	defineEmits<{
		(e: "click"): void;
	}>();
</script>

<template>
	<div @click="$emit('click')" class="profile-picture" :class="[size]">
		<template v-if="record">
			<cloudflare-image v-if="record?.profile_picture?.id ? true : false" :value="record?.profile_picture" :width="width" />
			<span v-else>{{ record.first_name.charAt(0) }}{{ record.last_name.charAt(0) }}</span>
		</template>
	</div>
</template>

<style scoped lang="scss">
	.profile-picture {
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		user-select: none;
		border-radius: 50%;
		.cloudflare-image {
			height: 100%;
			width: 100%;
			object-fit: cover;
		}

		span {
			font-weight: 500;
		}

		background: var(--black);
		span {
			color: var(--white);
		}

		&.tiny {
			height: 42px;
			width: 42px;

			span {
				font-size: 18px;
				letter-spacing: -0.4px;
			}
		}

		&.small {
			height: 42px;
			width: 42px;

			span {
				font-size: 18px;
				letter-spacing: -0.3px;
			}
		}

		&.medium {
			height: 56px;
			width: 56px;

			span {
				font-size: 22px;
				letter-spacing: -0.8px;
			}
		}

		&.large {
			height: 96px;
			width: 96px;

			span {
				font-size: 36px;
				letter-spacing: -1px;
			}
		}
	}
</style>
